import { apiSlice } from "./apiSlice";

export const bannerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createBanner: builder.mutation({
      query: (bannerData) => ({
        url: "/banners/createBanner",
        method: "POST",
        body: bannerData,
      }),
      invalidatesTags: ["Banner"],
    }),

    deleteBanner: builder.mutation({
      query: (id) => ({
        url: `/banners/deleteBanner/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Banner"],
    }),

    updateBanner: builder.mutation({
      query: ({ bannerData, id }) => ({
        url: `/banners/updateBanner/${id}`,
        method: "PATCH",
        body: bannerData,
      }),
      invalidatesTags: ["Banner"],
    }),

    getAllBanners: builder.query({
      query: () => ({
        url: "/banners/getAllBanners",
        method: "GET",
      }),
      providesTags: ["Banner"],
    }),

    getBannerById: builder.query({
      query: (id) => ({
        url: `/banners/getBannerById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateBannerMutation,
  useUpdateBannerMutation,
  useDeleteBannerMutation,
  useGetAllBannersQuery,
  useGetBannerByIdQuery,
} = bannerApi;
